export const trackEvent = (event, detail = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  // Every event carries its page context automatically — call sites only add
  // what is specific to the interaction (location, client_stage, etc.).
  const payload = {
    page_path: window.location.pathname,
    page_title: document.title,
    ...detail,
  };
  window.dataLayer.push({ event, ...payload });
  // Also deliver through the existing Google tag so GA4 receives these —
  // plain gtag.js never forwards raw dataLayer events on its own.
  // All of these are secondary engagement events; none are conversions.
  if (typeof window.gtag === "function") window.gtag("event", event, payload);
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
